import React, { useEffect } from 'react';
import '../styles/IndustriesPage.css';
import { Link } from 'react-router-dom';
import { allIndustriesData } from '../data/allIndustriesData';

const IndustriesPage: React.FC = () => {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="industries-page">
      <div className="industries-page-header">
        <h2 className="text-black text-4xl md:text-5xl font-bold animate-fade-in">
          Industries We Serve
        </h2>
      </div>
      
      <p className="industries-intro">
        At Betaque, we provide tailored technology solutions across diverse industries, leveraging our expertise to address 
        sector-specific challenges and drive innovation. Our deep industry knowledge enables us to deliver customized solutions 
        that help businesses achieve their strategic objectives and stay ahead in rapidly evolving markets.
      </p>
      
      <div className="industries-grid">
        {Object.values(allIndustriesData).map((industry) => (
          <Link to={`/industries/${industry.id}`} key={industry.id}>
            <div className="industry-card">
              <div className="industry-card-header">
                <h3 className="industry-title">{industry.hero.title}</h3>
                <p className="industry-subtitle">{industry.hero.subtitle}</p>
                <div className="industry-icon">
                  <span>{industry.hero.icon}</span>
                </div>
              </div>
              <div className="industry-content">
                <p className="industry-description">
                  {industry.hero.description}
                </p>
                <div className="industry-features">
                  {industry.hero.highlights && industry.hero.highlights.slice(0, 3).map((feature, index) => (
                    <div key={index} className="industry-feature">
                      <div className="industry-feature-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                      </div>
                      <div className="industry-feature-text">{feature}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>

      {/* Case Studies Section */}
      <div className="case-studies-section">
        <h3 className="case-studies-title">Success Stories</h3>
        
        <div className="case-studies-grid">
          <div className="case-study">
            <div className="case-study-header">
              <div className="case-study-industry">Healthcare</div>
              <h4 className="case-study-title">Medical Records Modernization</h4>
            </div>
            <div className="case-study-content">
              <p className="case-study-text">
                We helped a leading healthcare provider transition from legacy systems to a modern, HIPAA-compliant electronic 
                health records platform, improving data accessibility while maintaining the highest security standards.
              </p>
              <div className="case-study-results">
                <div className="case-study-result">
                  <div className="case-study-result-number">65%</div>
                  <div className="case-study-result-label">Faster Access</div>
                </div>
                <div className="case-study-result">
                  <div className="case-study-result-number">40%</div>
                  <div className="case-study-result-label">Cost Reduction</div>
                </div>
                <div className="case-study-result">
                  <div className="case-study-result-number">99.9%</div>
                  <div className="case-study-result-label">Uptime</div>
                </div>
              </div>
            </div>
          </div>

          <div className="case-study">
            <div className="case-study-header">
              <div className="case-study-industry">Finance</div>
              <h4 className="case-study-title">Fraud Detection System</h4>
            </div>
            <div className="case-study-content">
              <p className="case-study-text">
                We developed an AI-powered fraud detection system for a financial institution that analyzes transaction patterns 
                in real-time, significantly reducing fraudulent activities while minimizing false positives.
              </p>
              <div className="case-study-results">
                <div className="case-study-result">
                  <div className="case-study-result-number">87%</div>
                  <div className="case-study-result-label">Fraud Reduction</div>
                </div>
                <div className="case-study-result">
                  <div className="case-study-result-number">92%</div>
                  <div className="case-study-result-label">Detection Rate</div>
                </div>
                <div className="case-study-result">
                  <div className="case-study-result-number">5ms</div>
                  <div className="case-study-result-label">Response Time</div>
                </div>
              </div>
            </div>
          </div>

          <div className="case-study">
            <div className="case-study-header">
              <div className="case-study-industry">Manufacturing</div>
              <h4 className="case-study-title">IoT Predictive Maintenance</h4>
            </div>
            <div className="case-study-content">
              <p className="case-study-text">
                We implemented an IoT-based predictive maintenance solution for a global manufacturer, leveraging sensor data 
                and machine learning to predict equipment failures before they occur and optimize maintenance schedules.
              </p>
              <div className="case-study-results">
                <div className="case-study-result">
                  <div className="case-study-result-number">73%</div>
                  <div className="case-study-result-label">Downtime Reduction</div>
                </div>
                <div className="case-study-result">
                  <div className="case-study-result-number">32%</div>
                  <div className="case-study-result-label">Maintenance Savings</div>
                </div>
                <div className="case-study-result">
                  <div className="case-study-result-number">18%</div>
                  <div className="case-study-result-label">Productivity Gain</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndustriesPage; 